import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(!!localStorage.getItem('eg_token'));

  const refresh = useCallback(async () => {
    if (!localStorage.getItem('eg_token')) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const res = await api.get('/users/me');
      setUser(res.user);
      return res.user;
    } catch (e) {
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onLogout = () => setUser(null);
    window.addEventListener('eg:logout', onLogout);
    return () => window.removeEventListener('eg:logout', onLogout);
  }, [refresh]);

  const requestOtp = (phone) => api.post('/users/request-otp', { phone });
  const verifyOtp = async (phone, otp, name) => {
    const res = await api.post('/users/verify-otp', { phone, otp, name });
    localStorage.setItem('eg_token', res.token);
    setUser(res.user);
    return res.user;
  };
  const logout = () => {
    localStorage.removeItem('eg_token');
    setUser(null);
  };
  const toggleWishlist = async (productId) => {
    const res = await api.post(`/users/wishlist/${productId}`);
    setUser((u) => (u ? { ...u, wishlist: res.wishlist } : u));
    return res;
  };
  const updateMe = async (data) => {
    const res = await api.put('/users/me', data);
    setUser(res.user);
    return res.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin: user?.role === 'admin', requestOtp, verifyOtp, logout, refresh, toggleWishlist, updateMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
